import { useState } from 'react';
import { Box, Typography } from '@mui/material';
import HeadsetMicOutlinedIcon from '@mui/icons-material/HeadsetMicOutlined';
import '@fontsource/rubik';

/**
 * Floating support button – fixed bottom-right.
 * Expands on hover to reveal the support email address.
 */
export default function SupportFAB({ supportEmail = 'support@lucihub.com' }) {
  const [hovered, setHovered] = useState(false);

  return (
    <Box
      id="cd-support-fab"
      component="a"
      href={`mailto:${supportEmail}`}
      aria-label={`Contact support: ${supportEmail}`}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      sx={{
        position: 'fixed',
        bottom: 28,
        left: 28,
        display: 'flex',
        alignItems: 'center',
        overflow: 'hidden',
        maxWidth: hovered ? 300 : 48,
        height: 48,
        borderRadius: '48px',
        backgroundColor: '#08231B',
        cursor: 'pointer',
        textDecoration: 'none',
        boxShadow: hovered
          ? '0 8px 32px rgba(8,35,27,0.40), 0 2px 8px rgba(8,35,27,0.2)'
          : '0 4px 20px rgba(8,35,27,0.28)',
        zIndex: 50,
        transition: 'max-width 0.32s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.2s ease',
        transform: hovered ? 'translateY(-2px)' : 'translateY(0)',
      }}
    >
      {/* Icon */}
      <Box
        sx={{
          width: 48,
          height: 48,
          flexShrink: 0,
          display: 'grid',
          placeItems: 'center',
        }}
      >
        <HeadsetMicOutlinedIcon sx={{ fontSize: 20, color: '#00D744' }} />
      </Box>

      {/* Expandable label */}
      <Box
        sx={{
          opacity: hovered ? 1 : 0,
          transform: hovered ? 'translateX(0)' : 'translateX(-6px)',
          transition: 'opacity 0.18s ease 0.08s, transform 0.18s ease 0.08s',
          pr: 2.5,
          whiteSpace: 'nowrap',
          pointerEvents: hovered ? 'auto' : 'none',
        }}
      >
        <Typography
          sx={{
            fontFamily: 'Rubik',
            fontSize: '9px',
            fontWeight: 700,
            color: 'rgba(0,215,68,0.75)',
            letterSpacing: '0.14em',
            textTransform: 'uppercase',
            lineHeight: 1.3,
          }}
        >
          Need help?
        </Typography>
        <Typography
          sx={{
            fontFamily: 'monospace',
            fontSize: '12px',
            fontWeight: 600,
            color: '#f4f4f1',
            lineHeight: 1.3,
          }}
        >
          {supportEmail}
        </Typography>
      </Box>
    </Box>
  );
}
